import {ViolationService} from "violation/service";

import {useAuth} from "base/user/provider";
import {useCreateEntity} from "base/entity/hooks";
import {useViolationsTable} from "violation/data";

import {EntityListPage} from "base/entity/components/container";
import {ViolationFilterForm} from "violation/presentational/form";
import {CreateViolationForm} from "violation/container";

const ListViolationsPage = () => {
    const {tableColumns, getCellProps} = useViolationsTable();
    const auth = useAuth();
    let {
        button: createButton,
        dialog: createDialog,
        handleClickClose: closeDialog,
    } = useCreateEntity(
        null,
        "Nova infracção",
        <CreateViolationForm onCancel={() => closeDialog()} />
    );

    if (!auth.hasPermission("create-violations")) {
        createDialog = null;
        createButton = null;
    }

    return (
        <>
            {createDialog}
            <EntityListPage
                views={["table, map"]}
                entityName={{
                    singular: "Infracção",
                    plural: "Infracções",
                }}
                service={ViolationService}
                tableColumns={tableColumns}
                getCellProps={getCellProps}
                filterForm={<ViolationFilterForm />}
                createButton={createButton}
                disableNavigation
            />
        </>
    );
};
export default ListViolationsPage;
